import script from "./NewFormWithAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./NewFormWithAttendance.vue?vue&type=script&setup=true&lang=js"

import "./NewFormWithAttendance.vue?vue&type=style&index=0&id=4c29d343&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c29d343"]])

export default __exports__